import PROYECTO_COMENTARIOS from '@/graphql/querys/administracion/control-proyectos/comentarios/proyectoComentarios.gql';
import AGREGAR_PROYECTO_COMENTARIO from '@/graphql/mutations/administracion/control-proyectos/comentarios/agregarProyectoComentario.gql';
import REMOVER_PROYECTO_COMENTARIO from '@/graphql/mutations/administracion/control-proyectos/comentarios/removerProyectoComentario.gql';

export default {
  data() {
    return {
      mixEnviandoFormulario: false,
      mixComentario: {
        idProyecto: this.idProyecto,
        idRespuesta: null,
        comentario: null,
      },
      mixComentarioACitarTexto: null,
      proyectoComentariosQuery: {
        idProyecto: this.idProyecto,
        offset: null,
        limit: null,
      },
    };
  },
  apollo: {
    proyectoComentarios: {
      query: PROYECTO_COMENTARIOS,
      variables() {
        return {
          params: this.proyectoComentariosQuery,
        };
      },
    },
  },
  methods: {
    async mixCargarProyectoComentarios() {
      await this.$apollo.queries.proyectoComentarios.refetch({
        params: this.proyectoComentariosQuery,
      });
    },
    mixCitarComentario(comentario) {
      this.mixComentarioACitarTexto = comentario.comentario;
      this.mixComentario.idRespuesta = comentario.id;
    },
    mixCancelarCitarComentario() {
      this.mixComentarioACitarTexto = null;
      this.mixComentario.idRespuesta = null;
    },
    scrollBottom() {
      const container = document.getElementById('proyecto-comentarios-contenedor');
      if (container) {
        container.scrollTop = (container.scrollHeight - container.clientHeight);
      }
    },
    async mixGuardarProyectoComentario(comentario) {
      this.mixEsCargando();
      this.mixEnviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PROYECTO_COMENTARIO,
          variables: {
            comentario,
          },
          update: (store, { data: { agregarProyectoComentario } }) => {
            const query = {
              query: PROYECTO_COMENTARIOS,
              variables: {
                params: this.proyectoComentariosQuery,
              },
            };
            const { proyectoComentarios } = store.readQuery(query);
            const proyectoComentariosCopia = proyectoComentarios.slice();
            proyectoComentariosCopia.push(agregarProyectoComentario);
            store.writeQuery({
              ...query,
              data: {
                proyectoComentarios: proyectoComentariosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.scrollBottom();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.mixEnviandoFormulario = false;
    },
    // Eliminar Comentarios
    async mixEliminarProyectoComentario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PROYECTO_COMENTARIO,
        variables: {
          id: this.proyectoComentarioEliminar.id,
        },
        update: (store) => {
          const query = {
            query: PROYECTO_COMENTARIOS,
            variables: {
              params: this.proyectoComentariosQuery,
            },
          };
          const data = store.readQuery(query);
          const { proyectoComentarios } = data;
          const index = proyectoComentarios
            .findIndex((proyectoComentario) => proyectoComentario.id
            === this.proyectoComentarioEliminar.id);
          if (index !== -1) {
            proyectoComentarios.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    mixListadoProyectoComentarios() {
      if (!this.proyectoComentarios) return [];
      return [
        ...this.proyectoComentarios.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
      ];
    },
    mixGetUltimoMensaje() {
      if (!this.proyectoComentarios) return null;
      return this.mixListadoProyectoComentarios[0];
    },
  },
};
